import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 12,
  path: '/setting',
  component: Home,
  redirect: '/setting/setting/notice',
  name: 'setting',
  isHead: true,
  meta: {
    title: '系统配置',
    icon: 'el-icon-setting'
  },
  children: [
    {
      path: 'setting',
      component: () => import('@/views/setting/index'),
      name: 'Setting',
      meta: { title: '系统配置', close: false },
      children: [
        {
          path: 'notice',
          name: 'notice',
          component: () => import('@/views/department/notice/table'),
          meta: { title: '通知公告', next: '/setting/setting/permissionManage', close: true }
        },
        // 权限管理
        {
          path: 'permissionManage',
          name: 'permissionManage',
          component: () =>
            import('@/views/systemSetting/permissionManage/index'),
          meta: { title: '权限配置', next: '/setting/setting/roleManage', close: true }
        },
        {
          path: 'roleManage',
          name: 'roleManage',
          component: () =>
            import('@/views/systemSetting/roleManage/index'),
          meta: { title: '角色配置', next: '/setting/setting/AccountManagement', close: true }
        },
        // 账号管理
        {
          path: 'AccountManagement',
          name: 'AccountManagement',
          component: () => import('@/views/systemSetting/manageAccount/index'),
          meta: { title: '管理员账号配置', next: '/setting/setting/departmentManagement', close: true }
        },
        {
          path: 'departmentManagement',
          name: 'departmentManagement',
          component: () =>
            import('@/views/department/management/managementPage'),
          meta: { title: '部门账号配置', next: '/setting/setting/townManagement', close: true }
        },
        {
          path: 'townManagement',
          name: 'townManagement',
          component: () => import('@/views/town/management/managementPage'),
          meta: { title: '街镇账号配置', next: '/setting/setting/departmentTypeManage', close: true }
        },
        // 系统管理
        {
          path: 'departmentTypeManage',
          name: 'departmentTypeManage',
          component: () =>
            import('@/views/systemSetting/departmentTypeManage/index'),
          meta: { title: '部门类型管理', next: '/setting/setting/departmentManage', close: true }
        },
        {
          path: 'departmentManage',
          name: 'departmentManage',
          component: () =>
            import('@/views/systemSetting/departmentManage/index'),
          meta: { title: '部门层级配置', next: '/setting/setting/areaManagement', close: true }
        },
        {
          path: 'areaManagement',
          name: 'areaManagement',
          component: () => import('@/views/systemSetting/areaManagement'),
          meta: { title: '区域信息配置', next: '/setting/setting/firmnumber', close: true }
        },
        {
          path: 'firmnumber',
          name: 'firmnumber',
          component: () =>
            import('@/views/systemSetting/firmnumber'),
          meta: { title: '企业底数配置', next: '/setting/setting/riskDistribution', close: true }
        },
        {
          path: 'riskDistribution',
          name: 'riskDistribution',
          component: () =>
            import('@/views/systemSetting/riskDistribution'),
          meta: { title: '风险分布配置', next: '/setting/setting/operationParameter', close: true }
        },
        {
          path: 'operationParameter',
          name: 'operationParameter',
          component: () =>
            import('@/views/systemSetting/operationParameter'),
          meta: { title: '运行参数配置', next: '/setting/setting/operationLog', close: true }
        },
        {
          path: 'operationLog',
          name: 'operationLog',
          component: () =>
            import('@/views/systemSetting/operationLog'),
          meta: { title: '操作日志', next: '/setting/setting/entryLog', close: true }
        },
        {
          path: 'entryLog',
          name: 'entryLog',
          component: () =>
            import('@/views/systemSetting/entryLog'),
          meta: { title: '登录日志', close: true }
        },
      ]
    }
  ]
}

export default home



// WEBPACK FOOTER //
// ./src/router/modules/setting.js